// "off" | "prewarm" (mounted hidden to load) | "on".
import { resolveBoxTiming, resolveBoxEndFrame } from "../../../common/resolveBoxTiming.es6";
import { isYoutubeUrl } from "../../../common/youtube_tools";
import { AUDIO_PRELOAD_FRAMES, preloadsAudioCue } from "./audioCuePreload";

const FPS = 30;
// Mounted early so entry is a plain play().
export const VIDEO_PREROLL_FRAMES = 90;

// videoEndCache: a video without an end keeps its element's duration.
export function boxStage({ id, rawBox, toolbar, frame, recorderMode, videoEndCache }) {
  const currentFrame = frame || 0;
  const legacyAnims = window.IdealStudio?.State?.animationsById?.[id] || [];
  const { startFrame: resolvedStartFrame, endFrame: resolvedEndFrame } = resolveBoxTiming(
    rawBox,
    legacyAnims,
    FPS
  );
  const pluginId = toolbar?.pluginId;
  const exitDurationFrames = rawBox?.boxExitAnimation?.duration
    ? Math.round(rawBox.boxExitAnimation.duration * FPS)
    : 0;

  if (pluginId === "EnrichedPlayer") {
    // Without an explicit endFrame the end comes from the media duration.
    const tl = rawBox?.timeline;
    const vStart = typeof resolvedStartFrame === "number" ? resolvedStartFrame : 0;
    let stage = "on";
    if (currentFrame < vStart) {
      // Export seeks frame by frame and needs no pre-roll.
      if (
        recorderMode ||
        currentFrame < vStart - VIDEO_PREROLL_FRAMES ||
        isYoutubeUrl(toolbar?.state?.url)
      ) {
        return "off";
      }
      stage = "prewarm";
    }
    let vEnd = resolvedEndFrame;
    if (typeof vEnd !== "number") {
      const sig = `${tl?.trimStart}|${tl?.trimEnd}|${tl?.playStartFrame}|${vStart}`;
      const el = document.querySelector(`#box-${id} video`);
      const d = el && Number.isFinite(el.duration) && el.duration > 0 ? el.duration : null;
      if (d) {
        vEnd = resolveBoxEndFrame(rawBox, Math.round(d * FPS), legacyAnims, FPS);
        videoEndCache[id] = { sig, vEnd };
      } else {
        const cached = videoEndCache[id];
        if (cached && cached.sig === sig) vEnd = cached.vEnd;
      }
    }
    if (typeof vEnd === "number" && currentFrame > vEnd + exitDurationFrames) return "off";
    return stage;
  }

  if (typeof resolvedStartFrame === "number") {
    let stage = "on";
    if (currentFrame < resolvedStartFrame) {
      if (
        pluginId !== "AudioCue" ||
        recorderMode ||
        currentFrame < resolvedStartFrame - AUDIO_PRELOAD_FRAMES ||
        !preloadsAudioCue(rawBox, toolbar?.state)
      ) {
        return "off";
      }
      stage = "prewarm"; // mounted hidden; the cue stays silent until its start
    }
    if (
      typeof resolvedEndFrame === "number" &&
      currentFrame > resolvedEndFrame + exitDurationFrames
    ) {
      return "off";
    }
    return stage;
  }
  return "on";
}
